<div class="container" style="margin-top: 20px;">
        <div class="card-content big">
            <nav ngbNav #nav="ngbNav" (navChange)="onTabChange($event)" class="schedular-tab nav-tabs nav" [destroyOnHide]='true'>
                <ng-container ngbNavItem="AppointmentView">
                    <button translate ngbNavLink>lblDealerSchedule</button>

                    <ng-template ngbNavContent>
                        <div class="card">
                            <div class="card-body">
                                
                                <div class=" flgrow" *ngIf="dealers?.length > 0">
                                    <div class="form-row">
                                        <div class="col-xl-3 col-lg-6">
                                            <div class="relative flmid">
                                                
                                                <ng-select class="w-100" [(ngModel)]="dealerId"  name="dealerId" (change)="onDealerChange($event)" (keyup.enter)="onSearch()">
                                                    <ng-option [value]="-1" selected translate>lblSelectDealer</ng-option>
                                                    <ng-option *ngFor="let dealer of dealers" [value]="dealer.dealerId">
                                                        {{dealer.name}}
                                                    </ng-option>
                                                </ng-select>
                                
                                            </div>
                                        </div>
                                        <div class="col-auto pl-0">
                                            <button type="button" (click)="onSearch()" type="reset" aria-label="Center Align" class="add-button btn btn-primary"
                                              translate>
                            
                                              <em class="fas fa-search"></em>
                                            </button>
                                            <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
                                            (click)='RefreshDayData()'>
                                            <em class="fas fa-sync fa-lg"></em>
                                            </a>
                                    </div>
                                    <div *ngIf="noMechanicAssociated && isSearched" class="alert-dangero col-auto pr-0 ml-auto ng-star-inserted">
                                        <span class="align-middle" translate>lblnoMechanicAssociated</span>
                                    </div>
                                    </div>
                                </div>

                                    <ng-container *ngIf="isSearched">
                                        <app-af-scheduler-list [schedularHeader]="schedulerHeaderInfo" (onMonthChange)="schedulerMonthChange($event)"
                                            (onDayChange)="onDayChange($event)" [genericSchedulerList]="genericSchedulerListViewModel"
                                            [dealerWorkingHours]="dealerWorkingHours" [appointmentDate]="appointmentDate" [schedulerModal]="schedulerModal"
                                            [dealerHolidays]="dealerHolidays" [isView]="isView" (showAllMechanics)="onShowAllMechanics($event)"
                                            [selectedDate]="selectedDate" [isReadOnly]="true" (showAddBooking)="onAddBooking($event)"
                                            [isScheduleSummary]="false" [onScrollPlanning]="dayViewScrollLeft"
                                            (onMechanicScroll)="syncMechanicScroll($event)">
                                        </app-af-scheduler-list>
                                    </ng-container>
                                
                                    <ng-container *ngIf="appointmentSchedule && daySchedulerViewModel && isSearched">
                                        <af-app-scheduler-day-view #dayViewRef [hours]="hours" [appointmentSchedule]="appointmentSchedule"
                                            [daySchedulerViewModel]="daySchedulerViewModel" [isView]="isView" (showAddBooking)="onAddBooking($event)"
                                            [selectedDate]="selectedDate" [schedulerModal]="schedulerModal" [dealerName]="dealerName" [isReadOnly]="true"
                                            [selectedDealerId]="dealerId" (onScrollPlanning)="onDayViewScroll($event)">
                                        </af-app-scheduler-day-view>
                                        <div class="planning-legend">
                                            <!-- Row 1: Mechanic Status -->
                                            <div class="pl-row">
                                                <span class="pl-row-label">
                                                    <em class="fas fa-wrench pl-row-icon"></em>
                                                    <span translate>lblMechanicStatus</span>
                                                </span>
                                                <div class="pl-items">
                                                    <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#fff; box-shadow: inset 0 0 0 1.5px #aaa;"></span>
                                                        <span translate>lblAvailable</span>
                                                    </span>
                                                    <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#ffffd5; border:1px solid #ccc;"></span>
                                                        <span translate>lblOutForLunch</span>
                                                    </span>
                                                    <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#ceff0b; border:1px solid #ccc;"></span>
                                                        <span translate>lblBreakTimings</span>
                                                    </span>
                                                    <!-- <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#ff968a;"></span>
                                                        <span translate>lblOnLeave</span>
                                                    </span> -->
                                                    <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#d7d7df;"></span>
                                                        <span translate>lblNotAvailable</span>
                                                    </span>
                                                    <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#0380ca;"></span>
                                                        <span translate>lblReserveSlot</span>
                                                    </span>
                                                    <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#ecec6e; border:1px solid #ccc;"></span>
                                                        <span translate>lblWARPlanning</span>
                                                    </span>
                                                    <span class="pl-item">
                                                        <span class="pl-sq" style="background-color:#99cdba;"></span>
                                                        <span translate>lblTemparoryNotAvailable</span>
                                                    </span>
                                                    <span class="pl-item" *ngIf="isBlockMechanic">
                                                        <span class="pl-sq" style="background-color:#fc0303;"></span>
                                                        <span translate>lblBlockMechanic</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <!-- Row 2: Appointment Status -->
                                            <div class="pl-row">
                                                <span class="pl-row-label">
                                                    <em class="fas fa-calendar-alt pl-row-icon"></em>
                                                    <span translate>lblAppointmentStatus</span>
                                                </span>
                                                <div class="pl-items">
                                                    <span class="pl-item" *ngFor="let list of workOrderStatusList">
                                                        <span class="pl-sq" [style.background-color]="list.color"></span>
                                                        <span>{{list.status}}</span>
                                                    </span>
                                                </div>
                                            </div>
                                            <!-- Row 3: Mechanic Leave Types -->
                                            <div class="pl-row" *ngIf="mechanicLeaveTypesList?.length > 0">
                                                <span class="pl-row-label">
                                                    <em class="fas fa-door-open pl-row-icon"></em>
                                                    <span translate>lblMechanicLeaveType</span>
                                                </span>
                                                <div class="pl-items">
                                                    <span class="pl-item" *ngFor="let leave of mechanicLeaveTypesList">
                                                        <span class="pl-sq" [style.background-color]="leave.colorCode" [style.border]="!leave.colorCode ? '1px solid #aaa' : 'none'"></span>
                                                        <span translate>{{leave.leaveLabel}}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                
                        </div>
                        <div *ngIf="isErrorMessage && isSearched" class="alert alert-danger text-center mx-3">
                            <span class="font18" translate>lblDealerUnavailable</span>
                        </div>
                    </div>
                    </ng-template>
                </ng-container>
                    
                <ng-container ngbNavItem="Week View">
                    <button translate ngbNavLink >lblScheduleSummary
                    </button>

                    <ng-template ngbNavContent>
                        <div class="card">
                            <div class="card-body pb-0">
                                
                                <ng-container>
                                    <app-af-scheduler-list [schedularHeader]="schedulerHeaderInfo"
                                        (onMonthChange)="scheduleSummaryMonthChange($event)" 
                                        [isScheduleSummary] = "true"
                                        [dealerWorkingHours]="dealerWorkingHours" 
                                        [appointmentDate]="appointmentDate"
                                        [schedulerModal]="schedulerModal"
                                        [dealerHolidays]="dealerHolidays" 
                                        [isView]="isView"
                                        (showAllMechanics)="onShowAllMechanics($event)"                                   
                                        [selectedDate]="selectedDate" 
                                        [isReadOnly]="true"
                                        [dealerdata]="dealerData">
                                    </app-af-scheduler-list>
                                </ng-container>
                                
                            </div>
                      
                    </div>

                    <ng-container>
                        <ul class="list-inline mt-3 d-flex justify-content-end">
                            <li class="list-inline-item align-items-center ">
                                <strong class="color-bg align-middle" style="background-color:#d56a1d"></strong>
                                <span class="align-middle" translate>lblBookingExceeds75</span>
                            </li>
                            <li class="list-inline-item align-items-center ml-3">
                                <strong class="color-bg align-middle" style="background-color:#68a117"></strong>
                                <span class="align-middle" translate>lblPlanningpossible</span>
                            </li>
                            <li class="list-inline-item align-items-center ml-3">
                                <strong class="color-bg align-middle" style="background-color:#9d9d9d"></strong>
                                <span class="align-middle" translate>lblPlanningisnotpossible</span>
                            </li>
                        </ul>
                    </ng-container>   
                    </ng-template>
                </ng-container>
                <ng-container ngbNavItem="MonthWeekView">
                    <button translate ngbNavLink>Week View
                        </button>
                    <ng-template ngbNavContent>
                        <div class="card">
                            <div class="card-body">
                                <div class=" flgrow" *ngIf="dealers?.length > 0">
                                    <div class="form-row">
                                        <div class="col-xl-3 col-lg-6">
                                            <div class="relative flmid">
    
                                                <ng-select class="w-100" [(ngModel)]="weekViewDealerId" name="weekViewDealerId" (change)="onWeekViewDealerChange($event)" (keyup.enter)="onWeekViewDealerSearch()">
                                                    <ng-option [value]="-1" selected translate>lblSelectDealer</ng-option>
                                                    <ng-option *ngFor="let dealer of dealers" [value]="dealer.dealerId">
                                                        {{dealer.name}}
                                                    </ng-option>
                                                </ng-select>
    
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-lg-6">
                                            <button type="button" (click)="onWeekViewDealerSearch()" type="reset" aria-label="Center Align" class="add-button btn btn-primary" translate>
                                    
                                                      <em class="fas fa-search"></em>
                                                    </button>
                                        </div>
                                    </div>
                                </div>
    
    
                                <div class="month-Year-Main" *ngIf="showWeekView">
                                    <div class="d-flex align-items-center w-100">
    
                                        <div class="d-flex align-items-center m-auto"><button aria-label="Center Align" class="btn btn-outline-primary" (click)="PreviousMonth()"><em  class="fas fa-arrow-left fa-lg"></em></button>
                                            <div class="month-Year-child card-header text-center">
                                                {{currentMonthName}} - {{currentYear}} </div>
                                            <button aria-label="Center Align" class="btn btn-outline-primary"  (click)="NextMonth()"><em  class="fas fa-arrow-right fa-lg"></em></button></div>
    
                                    </div>
                                </div>
    
                                <div class="border" *ngIf="showWeekView">
    
                                
    
                                <ul class="custom-week-schedule month-byweek">
                                    <li class="time">
                                    </li>
                                    <li *ngFor="let item of weekArray;let indexOfelement=index;" [ngClass]="item.isActive ? 'byday active' : 'byday'">
                                        <h4 (click)="OnWeekClick(indexOfelement)">
                                            <span>Week</span>{{item.weekNumber}}
                                        </h4>                                        
                                    </li>
                                </ul>
                                <div class="custom-bycalendar">
                                    <ul class="custom-week-schedule weekly-byhour top-sticky">
                                        <li class="bytitle week-bg">
                                            <h5>Week {{weekArray[activeWeekIndex]?.weekNumber}} ( {{weekStartDate| date: 'dd MMM yyyy':'':'en-US'}} - {{weekEndDate| date: 'dd MMM yyyy':'':'en-US'}} ) </h5>
                                        </li>
                                        <li class="byday week-bg" *ngFor="let date of weekDates">
                                            <h5>{{date.day}}
                                                <span>{{date.weekShortName}}</span>
                                            </h5>
                                        </li>                                        
                                    </ul>
                                    <ul class="custom-week-schedule weekly-byhour" *ngFor="let data of workOrderData" style="border-bottom: 1px solid #ddd;">
                                        <!-- Row Start  -->
                                            <li class="time time-title">
                                                <h5 class="titleS16">{{data.mechanicName}}</h5>
                                            </li>
                                            <li class="byday" *ngFor="let workOrders of data.workOrderData">
                                                <p class="plan cursor" *ngFor="let dates of workOrders" (click)="OnWorkOrderClick(dates.appointmentId)"
                                                    (mouseenter)="showDetail(dates,data.mechanicName, $event)" (mouseleave)="hideDetail()">
                                                    {{dates.workOrderNumber}}, {{dates.totalHours}}
                                                </p>
                                            </li>
                                    </ul>
                                        <!-- Row /End  -->
                                      
                                      <!-- Tooltip -->
                                    <div *ngIf="isDetailVisible" class="tooltip-container" #tooltip
                                        [ngStyle]="{'top.px': slotDetailPosition.top, 'left.px': slotDetailPosition.left}">
                                        <div class="tooltip-arrow" [ngStyle]="{'top.px': arrowPosition.top, 'left.px': arrowPosition.left}"></div>
                                        <div class="tooltip-content">
                                        <app-week-planning-slot-detail [appointmentSlotDetails]="appointmentSlotDetails" [dealerName]="dealerName"
                                           [showTotalHours]="showTotalHours">
                                        </app-week-planning-slot-detail>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-start">
                                        <div class="col-auto column" *ngFor="let list of workOrderStatusList;">
                                            <div class="d-flex flex-row mt-2 ">
                                                <span class="color-bg" [style.background-color]="list.color"></span>
                                                &nbsp;
                                                <span class="status-name">{{list.status}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            </div>
                        </div>
                    </ng-template>
    
                </ng-container>
            </nav>
            <div [ngbNavOutlet]="nav"></div>
        </div>

</div>


